import React from 'react';
import './Header.css';

const Header = ({ currency, onCurrencyChange, onLogout, showLogout }) => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-logo">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
          </svg>
          <h1>earmiss</h1>
        </div>
        <div className="header-controls">
          {onCurrencyChange && (
            <div className="currency-selector">
              <button
                className={`currency-btn ${currency === 'USD' ? 'active' : ''}`}
                onClick={() => onCurrencyChange('USD')}
              >
                $ USD
              </button>
              <button
                className={`currency-btn ${currency === 'RUB' ? 'active' : ''}`}
                onClick={() => onCurrencyChange('RUB')}
              >
                ₽ RUB
              </button>
            </div>
          )}
          
          {showLogout && (
            <button className="logout-btn" onClick={onLogout} title="Выйти">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
